import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  CreateTicketPayload,
  CreateTicketResponse,
  TicketDetails,
  TicketMessage,
  TicketReplyPayload,
} from '../domain/ticket.models';
import { buildTicketFormData, resolveTicketMediaUrl } from './ticket-api.utils';

@Injectable({ providedIn: 'root' })
export class TicketApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiBaseUrl}/tickets`;

  getDetails(ticketNumber: string, page = 1, limit = 50): Observable<TicketDetails> {
    return this.http.get<TicketDetails>(
      `${this.baseUrl}/${encodeURIComponent(ticketNumber)}?page=${page}&limit=${limit}`,
    );
  }

  create(payload: CreateTicketPayload): Observable<CreateTicketResponse> {
    const { attachments, audio, video, ...data } = payload;
    const { description: rawDescription, ...ticketMetadata } = data;
    const description = rawDescription?.trim();
    const ticketData = description
      ? { ...ticketMetadata, description, text: description }
      : ticketMetadata;
    return this.http.post<CreateTicketResponse>(
      this.baseUrl,
      buildTicketFormData(
        ticketData,
        { attachments, audio, video },
      ),
    );
  }

  reply(ticketNumber: string, payload: TicketReplyPayload): Observable<TicketMessage> {
    return this.http.post<TicketMessage>(
      `${this.baseUrl}/${encodeURIComponent(ticketNumber)}/reply`,
      buildTicketFormData({ text: payload.text }, payload),
    );
  }

  markAsRead(messagesIds: string[]): Observable<unknown> {
    return this.http.patch(`${this.baseUrl}/messages/read`, { messagesIds });
  }

  resolveMediaUrl(path: string): string {
    return resolveTicketMediaUrl(path, environment.ticketCdnUrl);
  }
}

